export default "__VITE_ASSET__CIEqnnZ9__"